import api from "../api";
import { realityId } from "@/utils/reality-id";

export const getBlacklist = async () => {
  const res = await api.get<{ phones: string[]; emails: string[] }>(
    `blacklist?realityId=${realityId}`
  );

  return res.data;
};
